import PhotoSwipe from "photoswipe";
import "../../patterns/showcaseSwiper";
import "../../patterns/productsSwiper";
import PubSub from "../../utils/PubSub";
import { addToCart } from "./addToCart";
import addToFavorites from "./addToFavorites";
import { removeFromFavorites } from "../favorites/removeFromFavorites";
import { setupVariationHandler } from "./variationHandler";

document.addEventListener("DOMContentLoaded", function () {
  const addToCartForm = document.querySelector(".custom-add-to-cart-form");

  if (addToCartForm) {
    setupQuantityControls(addToCartForm);
    setupAddToCartHandler(addToCartForm);
  }

  // Tab functionality
  const tabHeaders = document.querySelectorAll(".product-tab-header");
  const tabContents = document.querySelectorAll(".product-tab-content");

  const setActiveTab = (clickedHeader) => {
    tabHeaders.forEach((h) => h.classList.remove("active"));
    tabContents.forEach((c) => c.classList.remove("active"));
    clickedHeader.classList.add("active");
    const tabId = clickedHeader.dataset.productTab;
    const contentElement = document.getElementById(tabId);
    if (contentElement) {
      contentElement.classList.add("active");
    }
  };

  tabHeaders.forEach((header) => {
    header.addEventListener("click", () => setActiveTab(header));
  });

  // Initialize all features
  setupFormMovement();
  setupFavoriteButtonMovement();
  setupFavoritesHandler();
  setupVariationHandler();
  setupNotifyStockFeature();
  setupProductLightbox(); // <-- ADDED: Initialize the new lightbox functionality
});

/**
 * NEW: Sets up the PhotoSwipe lightbox for the product gallery.
 */
function setupProductLightbox() {
  const galleryDataElement = document.getElementById("product-gallery-data");
  const galleryContainer = document.querySelector(
    ".showcase-swiper .swiper-wrapper"
  );

  if (!galleryDataElement || !galleryContainer) {
    return; // Exit if the data or gallery doesn't exist
  }

  // 1. Parse the image data from our script tag
  let lightboxImages;
  try {
    lightboxImages = JSON.parse(galleryDataElement.innerHTML);
  } catch (e) {
    console.error("Could not parse product gallery JSON data.", e);
    return;
  }

  if (!Array.isArray(lightboxImages) || lightboxImages.length === 0) {
    return;
  }

  // 2. Add a single click listener to the gallery container (event delegation)
  galleryContainer.addEventListener("click", function (e) {
    // Find the clicked slide
    const clickedSlide = e.target.closest(".swiper-slide");
    if (!clickedSlide) {
      return;
    }

    e.preventDefault();

    // 3. Get the index of the clicked slide
    const clickedIndex = parseInt(clickedSlide.dataset.pswpIndex, 10);
    if (isNaN(clickedIndex)) {
      return;
    }

    // 4. Initialize and open PhotoSwipe
    const lightbox = new PhotoSwipe({
      dataSource: lightboxImages,
      index: clickedIndex,
      // You can add more options here if needed.
      // See PhotoSwipe documentation for all options.
      // Example: showHideAnimationType: 'fade'
    });

    lightbox.init();
  });
}

function setupQuantityControls(form) {
  const quantityInput = form.querySelector('input[name="quantity"]');
  const minusBtn = form.querySelector(".minus");
  const plusBtn = form.querySelector(".plus");

  if (!quantityInput || !minusBtn || !plusBtn) return;

  const maxQuantity = parseInt(quantityInput.getAttribute("max"), 10) || 9999;

  const updateQuantity = (delta) => {
    const currentValue = parseInt(quantityInput.value, 10);
    let newValue = currentValue + delta;

    newValue = Math.max(1, newValue);
    newValue = Math.min(newValue, maxQuantity);

    quantityInput.value = newValue;
    updateQuantityButtonStates();
  };

  const updateQuantityButtonStates = () => {
    const currentValue = parseInt(quantityInput.value, 10);
    minusBtn.disabled = currentValue <= 1;
    plusBtn.disabled = currentValue >= maxQuantity;
  };

  updateQuantityButtonStates();

  quantityInput.addEventListener("change", () => {
    let value = parseInt(quantityInput.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    value = Math.min(value, maxQuantity);
    quantityInput.value = value;
    updateQuantityButtonStates();
  });

  minusBtn.addEventListener("click", () => updateQuantity(-1));
  plusBtn.addEventListener("click", () => updateQuantity(1));
}

function setupAddToCartHandler(form) {
  const button = form.querySelector(".custom-add-to-cart-button");
  const quantityInput = form.querySelector('input[name="quantity"]');
  const messageContainer = form.querySelector(".cart-message-container");

  const showMessage = (message, type) => {
    if (!messageContainer) return;
    messageContainer.textContent = message;
    messageContainer.className = "cart-message-container";
    messageContainer.classList.add("show", type);

    if (type !== "loading") {
      setTimeout(() => {
        messageContainer.classList.remove("show", type);
      }, 5000);
    }
  };

  const isSimpleProductForm = !form.querySelector('input[name="variation_id"]');
  if (button && button.disabled && isSimpleProductForm) {
    if (button.textContent !== cartVars.texts.outOfStock) {
      button.textContent = cartVars.texts.outOfStock;
    }
  }

  PubSub.subscribe("fetch:addToCart:start", () => {
    if (button) button.disabled = true;
    showMessage(cartVars.texts.addingToCart, "loading");
  });

  PubSub.subscribe("fetch:addToCart:success", ({ data }) => {
    if (data && data.cart_count !== undefined) {
      PubSub.publish("cart:addItem:success", { data });
      showMessage(cartVars.texts.addedToCart, "success");
      setTimeout(() => {
        const cartToggle = document.getElementById("cart-toggle");
        if (cartToggle) {
          cartToggle.click();
        }
      }, 500);
    } else {
      showMessage(cartVars.texts.addToCartError, "error");
    }
  });

  PubSub.subscribe("fetch:addToCart:error", ({ error, data }) => {
    if (data?.available_quantity !== undefined && quantityInput) {
      const newQuantity = Math.min(
        parseInt(quantityInput.value, 10),
        data.available_quantity
      );
      quantityInput.value = newQuantity;
      quantityInput.max = data.available_quantity;
      if (data.available_quantity > 0) {
        showMessage(cartVars.texts.quantityAdjusted, "error");
      } else {
        showMessage(error || cartVars.texts.stockUnavailable, "error");
        if (button) {
          button.textContent = cartVars.texts.outOfStock;
          button.disabled = true;
        }
      }
    } else {
      showMessage(error || cartVars.texts.addToCartError, "error");
    }
  });

  PubSub.subscribe("fetch:addToCart:end", () => {
    if (button && button.textContent !== cartVars.texts.outOfStock) {
      setTimeout(() => {
        button.disabled = false;
      }, 2000);
    }
  });

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    if (messageContainer)
      messageContainer.classList.remove("show", "error", "success", "loading");
    const maxStock = parseInt(quantityInput.getAttribute("max"), 10) || 9999;
    const requestedQuantity = parseInt(quantityInput.value, 10);

    if (requestedQuantity > maxStock) {
      const message =
        typeof sprintf === "function"
          ? sprintf(cartVars.texts.onlyXAvailable, maxStock)
          : `${cartVars.texts.onlyXAvailable.replace("%d", maxStock)}`;
      showMessage(message, "error");
      return;
    }
    await addToCart(new FormData(this));
  });
}

function setupFormMovement() {
  const form = document.querySelector(".custom-add-to-cart-form");
  const desktopContainer = document.querySelector(".purchase-info");
  const mobileContainer = document.querySelector(".form-placeholder");

  if (!form) {
    console.error(
      "Add to Cart form (.custom-add-to-cart-form) not found. Cannot setup movement."
    );
    return;
  }
  if (!mobileContainer) {
    console.error(
      "Mobile container (.form-placeholder) for Add to Cart form not found. Form may not display correctly on mobile."
    );
  }
  if (!desktopContainer && !mobileContainer) {
    console.error(
      "Neither desktop nor mobile container for Add to Cart form found. Form cannot be placed."
    );
    return;
  }

  function placeFormCorrectly() {
    const isMobile = window.matchMedia("(max-width: 900px)").matches;
    const currentParent = form.parentElement;

    if (isMobile) {
      if (mobileContainer) {
        if (currentParent !== mobileContainer) {
          mobileContainer.appendChild(form);
        }
      } else {
        if (desktopContainer && currentParent !== desktopContainer) {
          desktopContainer.appendChild(form);
        }
        console.warn(
          "Mobile container (.form-placeholder) missing. Add to Cart form might not display as intended on mobile."
        );
      }
      form.classList.add("mobile");
    } else {
      if (desktopContainer) {
        if (currentParent !== desktopContainer) {
          desktopContainer.appendChild(form);
        }
      } else {
        if (mobileContainer && currentParent !== mobileContainer) {
          mobileContainer.appendChild(form);
        }
        console.warn(
          "Desktop container (.purchase-info) missing. Add to Cart form might not display as intended on desktop."
        );
      }
      form.classList.remove("mobile");
    }
  }

  placeFormCorrectly();

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(placeFormCorrectly, 100);
  });
}

function setupFavoriteButtonMovement() {
  const favoriteBtn = document.querySelector(".favorite-toggle");
  const desktopContainer = document.querySelector(
    ".large-info-strip .product-header"
  );
  const mobileContainer = document.querySelector(
    ".mobile-product-header .product-header"
  );
  let currentlyMobile = window.matchMedia("(max-width: 900px)").matches;

  if (!favoriteBtn || !desktopContainer || !mobileContainer) return;

  function moveFavoriteButton() {
    const isMobile = window.matchMedia("(max-width: 900px)").matches;
    if (isMobile !== currentlyMobile) {
      currentlyMobile = isMobile;
      const targetContainer = isMobile ? mobileContainer : desktopContainer;
      favoriteBtn.classList.toggle("mobile", isMobile);
      targetContainer.appendChild(favoriteBtn);
    }
  }

  moveFavoriteButton();
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(moveFavoriteButton, 100);
  });
}

function setupFavoritesHandler() {
  const favoriteBtn = document.querySelector(".favorite-toggle");
  if (!favoriteBtn) return;

  const updateFavoriteButton = (isFavorite) => {
    const text = isFavorite
      ? favoritesVars.texts.removeFromFavorites
      : favoritesVars.texts.addToFavorites;
    favoriteBtn.classList.toggle("is-favorite", isFavorite);
    favoriteBtn.setAttribute("aria-label", text);
    const textElement = favoriteBtn.querySelector(".favorite-text");
    if (textElement) textElement.textContent = text;
  };

  PubSub.subscribe("fetch:addToFavorites:start", () => {
    favoriteBtn.disabled = true;
  });
  PubSub.subscribe("fetch:addToFavorites:success", () => {
    updateFavoriteButton(true);
  });
  PubSub.subscribe("fetch:removeFromFavorites:success", () => {
    updateFavoriteButton(false);
  });
  PubSub.subscribe("fetch:addToFavorites:end", () => {
    favoriteBtn.disabled = false;
  });
  PubSub.subscribe("fetch:removeFromFavorites:end", () => {
    favoriteBtn.disabled = false;
  });

  favoriteBtn.addEventListener("click", async function () {
    if (this.disabled) return;
    const productId = this.dataset.productId;
    const isFavorite = this.classList.contains("is-favorite");
    const formData = new FormData();
    formData.append("product_id", productId);

    if (isFavorite) {
      await removeFromFavorites(formData);
    } else {
      await addToFavorites(formData);
    }
  });
}

export function setupNotifyStockFeature() {
  // Select ONLY buttons that have not been initialized yet.
  const notifyButtons = document.querySelectorAll(
    ".js-notify-stock-button:not([data-initialized])"
  );
  const notifyToast = document.getElementById("notify-stock-toast");

  // If there are no NEW buttons to initialize, just stop.
  if (notifyButtons.length === 0) {
    return;
  }
  // If the toast doesn't exist at all, we can't do anything.
  if (!notifyToast) {
    return;
  }

  const closeToastButton = notifyToast.querySelector(
    ".notify-stock-toast-close"
  );
  const toastBodyContainer = notifyToast.querySelector(
    ".notify-stock-toast-body"
  );
  const submitNotifyButton = notifyToast.querySelector(
    "#notify-stock-submit-button"
  );
  const emailInput = notifyToast.querySelector("#notify-stock-email-input");
  const messageContainer = notifyToast.querySelector(
    ".notify-stock-toast-message"
  );
  const toastPromptParagraph = toastBodyContainer?.querySelector("p");

  // --- Functions to control the toast ---
  const showToast = (productId, variationId) => {
    notifyToast.dataset.productId = productId;
    notifyToast.dataset.variationId = variationId || "0";

    notifyToast.style.display = "block";
    requestAnimationFrame(() => {
      notifyToast.classList.add("show");
    });

    if (messageContainer) {
      messageContainer.textContent = "";
      messageContainer.style.display = "none";
      messageContainer.className = "notify-stock-toast-message";
    }

    if (toastBodyContainer) toastBodyContainer.style.display = "flex";
    if (toastPromptParagraph) toastPromptParagraph.style.display = "block";
    if (emailInput) {
      emailInput.style.display = "block";
      emailInput.value = "";
      emailInput.disabled = false;
    }
    if (submitNotifyButton) {
      submitNotifyButton.style.display = "block";
      submitNotifyButton.disabled = false;
      submitNotifyButton.textContent =
        window.notifyStockVars?.texts?.notify_me_button || "Notify Me";
    }
  };

  const hideToast = () => {
    notifyToast.classList.remove("show");
    notifyToast.addEventListener(
      "transitionend",
      () => {
        if (!notifyToast.classList.contains("show")) {
          notifyToast.style.display = "none";
        }
      },
      { once: true }
    );
  };

  // --- Attach listeners to all NEW, uninitialized buttons ---
  notifyButtons.forEach((button) => {
    button.setAttribute("data-initialized", "true");
    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const productId = button.dataset.productId;
      const variationId = button.dataset.variationId;
      showToast(productId, variationId);
    });
  });

  // --- Attach listeners ONCE to the single global toast element ---
  if (!notifyToast.dataset.listenersAttached) {
    notifyToast.dataset.listenersAttached = "true";

    if (closeToastButton) {
      closeToastButton.addEventListener("click", hideToast);
    }

    if (submitNotifyButton && emailInput && messageContainer) {
      submitNotifyButton.addEventListener("click", async () => {
        const email = emailInput.value.trim();
        const productId = notifyToast.dataset.productId;
        const variationId = notifyToast.dataset.variationId || "0";

        messageContainer.style.display = "none";
        const invalidEmailText =
          window.notifyStockVars?.texts?.invalidEmail ||
          "Please enter a valid email address.";

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          messageContainer.textContent = invalidEmailText;
          messageContainer.classList.add("error");
          messageContainer.style.display = "block";
          return;
        }

        emailInput.disabled = true;
        submitNotifyButton.disabled = true;
        submitNotifyButton.textContent =
          window.notifyStockVars?.texts?.sending || "Sending...";

        const formData = new FormData();
        formData.append("action", "handle_stock_notification_request");
        formData.append("nonce", window.notifyStockVars.nonce);
        formData.append("product_id", productId);
        formData.append("variation_id", variationId);
        formData.append("email", email);

        try {
          const response = await fetch(window.notifyStockVars.ajaxUrl, {
            method: "POST",
            body: formData,
          });
          const data = await response.json();

          if (data.success) {
            messageContainer.textContent =
              data.message ||
              window.notifyStockVars?.texts?.notify_request_successful ||
              "Request successful!";
            messageContainer.classList.add("success");
            if (toastBodyContainer) toastBodyContainer.style.display = "none";
          } else {
            messageContainer.textContent =
              data.message ||
              window.notifyStockVars?.texts?.notify_request_failed ||
              "An error occurred.";
            messageContainer.classList.add("error");
            emailInput.disabled = false;
            submitNotifyButton.disabled = false;
            submitNotifyButton.textContent =
              window.notifyStockVars?.texts?.notify_me_button || "Notify Me";
          }
        } catch (error) {
          messageContainer.textContent =
            window.notifyStockVars?.texts?.error_general ||
            "An error occurred.";
          messageContainer.classList.add("error");
          emailInput.disabled = false;
          submitNotifyButton.disabled = false;
          submitNotifyButton.textContent =
            window.notifyStockVars?.texts?.notify_me_button || "Notify Me";
        }
        messageContainer.style.display = "block";
      });
    }

    document.addEventListener("click", (event) => {
      if (
        notifyToast.classList.contains("show") &&
        !notifyToast.contains(event.target) &&
        !event.target.closest(".js-notify-stock-button")
      ) {
        hideToast();
      }
    });
  }
}
